// deck.gl takes colours as [red, green, blue] numbers, while Tailwind's config holds hex strings like '#2E90FA'
export default function hexToRgb(hex: string): [number, number, number] {
  const digits = hex.replace('#', '');
  const toChannel = (start: number) => Number.parseInt(digits.slice(start, start + 2), 16);
  return [toChannel(0), toChannel(2), toChannel(4)];
}
